import styled from "styled-components";

export const FlexH = styled.div`
    display: flex;
    flex-direction: row;
`;

export const FlexV = styled.div`
    display: flex;
    height: inherit;
    flex-direction: column;
    justify-content: center;
`;

export const CenterLayout = styled.div<{$width?: number}>`
    margin: auto;
    width: ${(props) => props.$width || 600}px;
    height: inherit;
`;

export const AlignCenter = styled.div`
    text-align: center;
`;

/**
 * size1만 입력하면, 동일한 값으로 4방향 패딩 적용.
 * size2까지 입력하면, size1은 좌우, size2는 상하 패딩
 */
export const Padding = styled.div<{$size1: number, $size2?: number}>`
    width: 100%;
    height: 100%;
    padding: ${(props) => props.$size1 }px ${(props) => props.$size2 || props.$size1}px;
`;

export const VerticalSpaceBetween = styled.div<{height?: number}>`
    display: flex;
    height: ${(props) => props.height ? props.height + 'px' : '100%'};
    flex-direction: column;
    justify-content: space-between;
    gap: 20px;
`;